
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Cart } from "@/types/Cart";
import { CartItemPaymentTerms } from "@/types/cart-item";
import app_config from "../../app_config.json";

const { State } = namespace("Root");

@Component
export default class PaymentSchedule extends Vue {
  @State("cart") cart!: Cart;
  @Prop() cart_item_id!: number;

  constructor() {
    super();
  }

  created() {
    if (!this.cart_item_id) {
      return;
    }

    const item = this.cart.getItemById(this.cart_item_id);
    if (!item) {
      return;
    }

    if (item.payment_terms != CartItemPaymentTerms.Monthly) {
      return;
    }
  }

  get rates() {
    const item = this.cart.getItemById(this.cart_item_id);
    if (!item || item.payment_terms != CartItemPaymentTerms.Monthly) {
      return [];
    }
    let rates: any[] = [];
    let date = new Date();
    for (let i = 0; i < item.policy_term * 12 - 1; i++) {
      date.setMonth(date.getMonth() + 1);
      let rate = {
        date: this.getDateFormatted(date),
        due: item.due_today + app_config.wag_api.order.monthly_processing_fee,
      };
      rates.push(rate);
    }
    return rates;
  }

  get due_today() {
    const item = this.cart.getItemById(this.cart_item_id);
    if (!item || item.payment_terms != CartItemPaymentTerms.Monthly) {
      return 0;
    }

    return item.due_today + app_config.wag_api.order.monthly_processing_fee;
  }

  getDateFormatted(date: Date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return month + "/" + day + "/" + year;
  }
}
